// fetch() support
require('whatwg-fetch');
